module.exports = __webpack_public_path__ + "static/media/banner2.ae1ed8fe.jpg";